import { render } from "./HospitalScreenTable.vue?vue&type=template&id=90877de0&scoped=true"
import script from "./HospitalScreenTable.vue?vue&type=script&lang=js"
export * from "./HospitalScreenTable.vue?vue&type=script&lang=js"

import "./HospitalScreenTable.vue?vue&type=style&index=0&id=90877de0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90877de0"]])

export default __exports__